import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RateLimits from '../../components/RateLimits';

import { loginRequest } from '@xanadu/ui-shared/modules/userSession/actions';

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loginRequest
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    message: state.getIn(['application', 'rateLimitMessages']).last(),
    isLoggedIn: state.getIn(['user', 'isLoggedIn'])
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RateLimits);
